import { useTranslation } from "react-i18next";

export const useI18qualitiesModule = () => {
  const { t } = useTranslation();

  const qualitiesData = [
    {
      icon: "confidential2",
      iconShow: true,
      title: t("qualitiesModule.title.1"),
      desc: t("qualitiesModule.desc.1"),
    },
    {
      icon: "globe",
      iconShow: true,
      title: t("qualitiesModule.title.2"),
      desc: t("qualitiesModule.desc.2"),
    },
    {
      icon: "noLogging",
      iconShow: true,
      title: t("qualitiesModule.title.3"),
      desc: t("qualitiesModule.desc.3"),
    },
  ];

  return { qualitiesData };
};
